import { render } from "./iconFilter.vue?vue&type=template&id=a0509340"
import script from "./iconFilter.vue?vue&type=script&lang=js"
export * from "./iconFilter.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__